import { Match } from 'effect';
import type { PointerEvent } from 'react';

export type IntentSource = 'pointer' | 'focus';

type IntentCallbacks = {
  readonly start: (source: IntentSource) => void;
  readonly cancel: (source: IntentSource) => void;
};

/** Translates pointer and focus events into independent intent channels. */
export const intentHandlers = ({ start, cancel }: IntentCallbacks) => ({
  onPointerEnter: (event: PointerEvent<HTMLElement>) => {
    Match.value(event.pointerType).pipe(
      Match.when('touch', () => {}),
      Match.orElse(() => start('pointer'))
    );
  },
  onPointerLeave: () => cancel('pointer'),
  onFocus: () => start('focus'),
  onBlur: () => cancel('focus'),
});
